import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

export class PaymentPoints extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название ПВП",
                accessor: "tollBooth",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.paymentPointsShow(id)}>{value}</Link>,
            },
            {
                Header: "Трасса",
                accessor: "highway",
                filterable: true,
            },
            {
                Header: "Координаты",
                sortable: false,
                accessor: "location.coordinates",
                Cell: ({ value }) => value.join(", "),
            },
        ];
    }

    renderCreateButton = () => {
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.paymentPointsNew,
        };
        return <Link {...props}>{this.props.createBtnText}</Link>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(PaymentPoints, "payment-points");
